import React, { useState } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import './Exam.css';
import Footer from '../../Footer';
import { questionsByRole } from './ExamQuestions';

const Exam = () => {
  const { userType } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const roleParam = queryParams.get('type');

  // Handle missing role (e.g., for applicants)
  var selectedRole = roleParam;
  if (userType && userType.toLowerCase() === 'applicant') {
    selectedRole = 'applicant';
  }

  // Validate role + fetch questions
  var questions = [];
  if (selectedRole && questionsByRole[selectedRole.toLowerCase()]) {
    questions = questionsByRole[selectedRole.toLowerCase()];
  }

  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [selectedAnswers, setSelectedAnswers] = useState({});

  if (!userType || questions.length === 0) {
    return (
      <div className="exam-error">
        <h2>Oops — Exam Not Found</h2>
        <p>Please return to the exam start page and select a valid type and role.</p>
      </div>
    );
  }

  const currentQuestion = questions[currentQuestionIndex];
  const selected = selectedAnswers[currentQuestionIndex];

  const handleOptionSelect = (option) => {
    var updatedAnswers = Object.assign({}, selectedAnswers);
    updatedAnswers[currentQuestionIndex] = option;
    setSelectedAnswers(updatedAnswers);
  };

  const handleNext = () => {
    if (currentQuestionIndex < questions.length - 1) {
      setCurrentQuestionIndex(currentQuestionIndex + 1);
    } else {
      // Calculate score
      const correctAnswers = questions.filter((q, i) => selectedAnswers[i] === q.answer).length;
      const score = Math.round((correctAnswers / questions.length) * 100);
  
      // Navigate to results page with state
      navigate('/exam/result', {
        state: {
          selectedRole,
          score,
          selectedAnswers,
          questions,
        },
      });
    }
  };  

  const handleBack = () => {
    if (currentQuestionIndex > 0) {
      setCurrentQuestionIndex(currentQuestionIndex - 1);
    }
  };

  return (
    <>
      <div className="store-container">
        <div className='exam-question-box'>
          <h2 className='exam-header'>
            {selectedRole.charAt(0).toUpperCase() + selectedRole.slice(1)} Exam
          </h2>
          <h3 className='exam-question-number'>{currentQuestionIndex + 1} of {questions.length}</h3>
          <p className='exam-question-text'>{currentQuestion.question}</p>
          <ul className='exam-options'>
            {currentQuestion.options.map(function (option, index) {
              return (
                <li key={option}>
                  <button
                    className={'exam-option-button' + (selected === option ? ' exam-selected' : '')}
                    onClick={function () {
                      handleOptionSelect(option);
                    }}
                  >
                    {index + 1}. {option}
                  </button>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
      <div className='exam-nav'>
        {currentQuestionIndex > 0 && (
          <button onClick={handleBack} className='exam-button exam-back-button'>
            Back
          </button>
        )}
        <button onClick={handleNext} className='exam-button exam-next-button' disabled={!selected}>
          {currentQuestionIndex === questions.length - 1 ? 'Submit' : 'Next'}
        </button>
      </div>
      <hr />
      <Footer />
    </>
  );
};

export default Exam;
